import React, { useState } from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import { Box, Typography } from "@mui/material";
import { SortDIcons } from "../../../Assets/Table/SortDIcons";
import { HospitalIcon } from "../../../Assets/Table/HospitalIcon";
import { MedicalCareIcon } from "../../../Assets/Table/MedicalCareIcon";
import { WallClockIcon } from "../../../Assets/Table/WallClockIcon";
import InfiniteScroll from "react-infinite-scroll-component";
import { useNavigate } from "react-router-dom";

const Doctor = ({ tableHead, loadAllTask, taskList }) => {
  const [hover, setHover] = useState(0);
  const navigate = useNavigate();
  const handleOpenPopUp = (data) => {
    navigate("/doctorAddPage", { state: { id: data, isLive: "isLive" } });
  };
  const splitDateAndTime = (dateTimeString) => {
    const dateObj = new Date(dateTimeString);

    const time = dateObj.toLocaleTimeString([], {
      hour: "2-digit",
      minute: "2-digit",
    });
    const date = dateObj
      .toLocaleDateString([], {
        day: "2-digit",
        month: "2-digit",
        year: "numeric",
      })
      .replace(/\//g, "-");
    return { date, time };
  };

  return (
    <Box
      sx={{
        padding: "10px 20px",
      }}>
      <TableContainer
        component={Paper}
        sx={{
          backgroundColor: "#F9FBFC",
          maxHeight: "82vh",
        }}>
        <InfiniteScroll
          dataLength={taskList.length}
          next={loadAllTask}
          hasMore={true}
          height={"75vh"}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead
              sx={{
                position: "sticky",
                top: 0,
                backgroundColor: "#F9FBFC",
                zIndex: 999,
              }}>
              <TableRow>
                <TableCell align="left">
                  <Typography sx={tableHead}>
                    Time
                    <Box sx={{ cursor: "pointer" }}>
                      <SortDIcons />
                    </Box>
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  {" "}
                  <Typography sx={tableHead}>
                    Subject
                    <Box
                      sx={{ cursor: "pointer", transform: "rotate(180deg)" }}>
                      <SortDIcons />
                    </Box>
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  {" "}
                  <Typography sx={tableHead}>
                    Item
                    <Box sx={{ cursor: "pointer" }}>
                      <SortDIcons />
                    </Box>
                  </Typography>
                </TableCell>
                <TableCell align="left">
                  <Typography sx={tableHead}>
                    Status
                    <Box sx={{ cursor: "pointer" }}>
                      <SortDIcons />
                    </Box>
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {taskList?.map((task) => {
                return (
                  <TableRow
                    component={"div"}
                    align="left"
                    key={task?.typeId}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                      cursor: "pointer",
                      position: "relative",
                    }}
                    onMouseEnter={() => setHover(task?.typeId)}
                    onMouseLeave={() => setHover(0)}
                    onClick={() => handleOpenPopUp(task?.typeId)}>
                    <>
                      <TableCell component="th" scope="row">
                        <Box
                          sx={{
                            display: "flex",
                            alignContent: "center",
                            gap: 1,
                          }}>
                          <Box>
                            <Typography sx={tableHead}>
                              {splitDateAndTime(task?.date)?.date}
                            </Typography>
                            <Typography
                              sx={{
                                fontSize: "13px",
                                color: "#4C5A6A",
                              }}>
                              {splitDateAndTime(task?.date)?.time}
                            </Typography>
                          </Box>
                          <Box
                            sx={{
                              display: "flex",
                              bgcolor: "#788597",
                              alignItems: "center",
                              justifyContent: "center",
                              width: "50px",
                              height: "22px",
                              borderRadius: "20px",
                              color: "white",
                              fontSize: "11px",
                              marginTop: 1,
                            }}>
                            New
                          </Box>
                        </Box>
                      </TableCell>
                      <TableCell
                        align="left"
                        sx={{
                          fontSize: "14px",
                          color: "#4C5A6A",
                        }}>
                        Onboarding details added
                      </TableCell>
                      <TableCell align="left">
                        <Typography
                          sx={{
                            fontSize: "15px",
                            color: "#2E2E2E",
                            fontWeight: 600,
                            display: "flex",
                            alignItems: "center",
                            gap: 1,
                          }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}>
                            {task?.dataType === "HOSPITAL" ? (
                              <HospitalIcon />
                            ) : (
                              <MedicalCareIcon />
                            )}
                          </Box>
                          {task?.typeName}
                        </Typography>
                      </TableCell>
                      <TableCell align="left">
                        <Box
                          component={"span"}
                          sx={{
                            display: "flex",
                            gap: 1,
                            color: "#DC8E1F",
                            fontSize: "14px",
                          }}>
                          <Box
                            sx={{
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}>
                            <WallClockIcon />
                          </Box>
                          Pending
                        </Box>
                      </TableCell>
                    </>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </InfiniteScroll>
      </TableContainer>
    </Box>
  );
};

export default Doctor;
